export default "__VITE_ASSET__C4Lfif9X__"